import React from 'react';
import { selectTranslations } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import I18NLocaleService from 'mt-react-common/modules/i18n/services/I18NLocaleService';
import { template, printHtml, htmlTagsExist } from './';
import store from '../store';

// Переводит источник если такой есть в справочнике
export const tByStore = (translations, sourceMessage, templateData) => {
  const found = translations.find(item => item.s === sourceMessage);
  let translateMessage = found ? found.t : undefined;
  let isNotFound = false;

  if (!found) {
    if (!window.notFoundTranslateMessages) {
      window.notFoundTranslateMessages = [];
    }
    if (!window.notFoundTranslateMessages.includes(sourceMessage)) {
      window.notFoundTranslateMessages.push(sourceMessage);
      I18NLocaleService.sendNotFoundMessageAction(sourceMessage).then();
    }
  }

  if (!translateMessage) {
    isNotFound = true;
    translateMessage = sourceMessage;
  }

  if (templateData) {
    translateMessage = template(translateMessage, templateData);
    if (isNotFound) {
      translateMessage = (
        <React.Fragment>
          t{'{'}
          {translateMessage}
          {'}'}
        </React.Fragment>
      );
    }
  } else if (isNotFound) {
    translateMessage = `$t{${translateMessage}}`;
  }

  return htmlTagsExist(translateMessage)
    ? printHtml(translateMessage)
    : translateMessage;
};

export const t = (sourceMessage, templateData) => {
  const translations = selectTranslations(store.getState());
  return tByStore(translations, sourceMessage, templateData);
};

// Берет справочники из window, для возможности использовать в redux
export const tWind = (sourceMessage, templateData) => {
  const translations = window.back_translations;
  return tByStore(translations, sourceMessage, templateData);
};

export default null;



// WEBPACK FOOTER //
// ./src/utils/translates.js